import React from 'react';
import PropTypes from 'prop-types';
import FieldList from './FieldList';
import { ContentWrapper, ContentTitleWrapper } from '../BoxscoreInfo.style';

const Content = (props) => {
    const { info = [] } = props;
    return info.map(({ title, fieldList }, i) => {
        return (
            <ContentWrapper key={i}>
                <ContentTitleWrapper>{title}</ContentTitleWrapper>
                <FieldList list={fieldList} />
            </ContentWrapper>
        );
    });
};

Content.propTypes = {
    info: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string,
        fieldList: PropTypes.array
    }))
};

export default Content;
